import { create } from 'zustand'
import { getMe, logout as apiLogout } from '../api/auth'

/**
 * Real auth store backed by the Flask backend session.
 *
 * - fetchUser() calls /api/v1/auth/me on app startup.
 * - logout() calls /api/v1/auth/logout and clears local state.
 */
export const useAuthStore = create((set) => ({
  user: null,
  isLoading: true,

  fetchUser: async () => {
    try {
      const user = await getMe()
      set({ user, isLoading: false })
    } catch {
      set({ user: null, isLoading: false })
    }
  },

  setUser: (user) => {
    set({ user, isLoading: false })
  },

  logout: async () => {
    try {
      await apiLogout()
    } finally {
      set({ user: null, isLoading: false })
    }
  },
}))
